import designDataPanelComponent from './ui/designDataPanelComponent';
import designDataPanelStandalone from './ui/designDataPanelStandalone';

export {
  designDataPanelComponent as panel,
  designDataPanelStandalone as standalone,
};
